import * as tslib_1 from "tslib";
import { ContainerBase } from '../../../core/base/container-base';
import { OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as customer from '../../actions/customer';
import * as user from '../../actions/user';
import * as fromAuth from '../../reducers';
import { takeUntil } from 'rxjs/operators';
import { PageRoutingService } from '../../../core/services/page-routing.service';
var CustomerSelectionContainer = /** @class */ (function (_super) {
    tslib_1.__extends(CustomerSelectionContainer, _super);
    function CustomerSelectionContainer(store, pageRoutingSvc) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.pageRoutingSvc = pageRoutingSvc;
        _this.pageRoutingSvc.breadcrumbsStatus = false;
        return _this;
    }
    CustomerSelectionContainer.prototype.ngOnInit = function () {
        this.store.dispatch(new customer.Get());
        this.customers$ = this.store.pipe(select(fromAuth.getCustomersList), takeUntil(this.destroyed$));
        this.customerSelected$ = this.store.pipe(select(fromAuth.isCustomerSelected), takeUntil(this.destroyed$));
        this.isLoading$ = this.store.pipe(select(fromAuth.customersIsLoading), takeUntil(this.destroyed$));
    };
    CustomerSelectionContainer.prototype.ngOnDestroy = function () {
        this.pageRoutingSvc.breadcrumbsStatus = true;
    };
    CustomerSelectionContainer.prototype.expand = function () {
        this.store.dispatch(new customer.Expand());
    };
    CustomerSelectionContainer.prototype.search = function (searchTerm) {
        searchTerm.length
            ? this.store.dispatch(new customer.Search(searchTerm))
            : this.store.dispatch(new customer.Get());
    };
    CustomerSelectionContainer.prototype.select = function (customer) {
        this.store.dispatch(new user.SetCustomer(customer._id));
    };
    return CustomerSelectionContainer;
}(ContainerBase));
export { CustomerSelectionContainer };
